import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { Card } from './ui/Card';
import { Reveal } from './ui/Reveal';
import { Award, Star, Medal } from 'lucide-react';
const awards = [{
  title: 'Distinguished Service Medal',
  icon: Medal
}, {
  title: 'Legion of Merit (3x)',
  icon: Star
}, {
  title: 'Bronze Star Medal',
  icon: Award
}, {
  title: 'NATO Medal',
  icon: GlobeIcon
}, {
  title: 'Superior Civilian Service Medal (2x)',
  icon: Medal
}];
// Helper since Globe isn't imported from lucide in the original file
function GlobeIcon(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-50">
      <circle cx="12" cy="12" r="10" data-id="element-51" />
      <line x1="2" x2="22" y1="12" y2="12" data-id="element-52" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" data-id="element-53" />
    </svg>;
}
export function AwardsSection() {
  return <Section id="awards" variant="navy" data-id="element-54">
      <SectionHeader title="Decorations & Honors" subtitle="Recognition of Service" data-id="element-55" />

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4" data-id="element-56">
        {awards.map((award, index) => <Reveal key={index} delay={index * 100} data-id="element-57">
            <Card className="flex flex-col items-center justify-center text-center p-6 h-full hover:bg-navy-800 transition-colors" data-id="element-58">
              <div className="w-12 h-12 rounded-full bg-navy-900 border border-gold-500 flex items-center justify-center mb-4 shadow-[0_0_15px_rgba(197,165,90,0.2)]" data-id="element-59">
                <award.icon className="text-gold-500 w-6 h-6" data-id="element-60" />
              </div>
              <h4 className="text-white font-bold text-sm uppercase mb-1" data-id="element-61">
                {award.title}
              </h4>
            </Card>
          </Reveal>)}
      </div>
    </Section>;
}